import { Injectable, inject } from '@angular/core';
import svg2pdf from 'svg2pdf.js';
declare let jsPDF: any;
import { SortService } from '../../../util/sort.service';
import { PDFService } from './pdf.service';

@Injectable({
  providedIn: 'root'
})
export class OTSExportpdfService {
  private sortService = inject(SortService);
  private pdfService = inject(PDFService);


  svgText: any;
  programDashboard: string = 'Insight Status Report';

  constructor() {
    this.svgText = this.pdfService.loadSvg('assets/logo.svg');
  }

  exportIssueReport = (pdfData: any) => {
    const pdf = new jsPDF('p', 'pt', 'letter');
    this.pdfService.writeHeader(pdf, pdfData.clientCode, pdfData.dateString, this.programDashboard);
    this.pdfService.writeFooter(pdf);
    

    this.writeTableOnlyTopdf(pdf, pdfData.chartData, '', this.programDashboard, pdfData.clientCode, pdfData.dateString, true, false, this.programDashboard).then(() => {
      pdf.save(`${pdfData.clientCode}-${this.programDashboard}.pdf`);
    });

  }

  writeChartTopdf = (pdf: any, chartData: any, id: string, chartName: string, clientName: string, dateString: string, addDataTable: boolean = false, addPage: boolean = true) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      if (addPage) {
        this.pdfService.addPage(pdf, clientName, dateString, this.programDashboard);
      }
      this.drawfullWidthRectangle(pdf);

      const chartSVG = document.getElementById(id).getElementsByTagName('svg')[0];
      this.convertSvgToPdf(chartSVG, pdf, {
        xOffset: 48,
        yOffset: 134,
        scale: 0.75,
      });
      pdf.setFont('verdana');
      pdf.setTextColor(88, 88, 88);
      pdf.setFontSize(14);
      pdf.text(chartName, 24, 110);

      if (addDataTable) {
        pdf.setFontSize(9);
        pdf.text('Tabular data continued in next page...', 24, 480);

        this.pdfService.addPage(pdf, clientName, dateString, this.programDashboard);
        pdf.setFont('verdana');
        pdf.setTextColor(88, 88, 88);
        pdf.setFontSize(14);
        pdf.text(chartName + ' - Tabular Data', 24, 110);

        const tableData: any = []
        if (chartData['dataTable']) {
          chartData['dataTable'].forEach((row: any[], rowIndex: number) => {
            tableData[rowIndex] = [];
            row.forEach((col: any, colIndex) => {
              tableData[rowIndex][colIndex] = col;
            });
          });

          const tableTranspose = tableData[0].map((col, i) => tableData.map(row => row[i]));
          const columns = tableTranspose[0];

          tableTranspose.splice(0, 1);
          tableTranspose.sort(this.sortFunction);

          const styles: any = {
            0: { fontStyle: 'normal', halign: 'left' }
          };
          this.addTableForCharts(pdf, columns, tableTranspose, 126, 24, styles, clientName, dateString, chartName);
        }
      }

      resolve('done');
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeTableOnlyTopdf = (pdf: any, chartData: any, id: string, chartName: string, clientName: string, dateString: string, addDataTable: boolean = false, addPage: boolean = true, programDashboard: string = this.programDashboard) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      if (addPage) {
        this.pdfService.addPage(pdf, clientName, dateString, programDashboard);
      }

      pdf.setFont('verdana');
      pdf.setTextColor(88, 88, 88);

      const tableData: any = []
      chartData.forEach((row: any[], rowIndex: number) => {
        tableData[rowIndex] = [];
        row.forEach((col: any, colIndex) => {
          tableData[rowIndex][colIndex] = col;
        });
      });
      const columns = tableData[0];
      tableData.splice(0, 1);
      const styles: any = {
       // 0: { fontStyle: 'normal', halign: 'left', fontSize: 8 }
      };
      //tableData.sort(this.sortFunction);
      if (tableData.length) {
        this.addTableForCharts(pdf, columns, tableData, 126, 24, styles, clientName, dateString, chartName, programDashboard);
      }

      resolve('done');
    });
  }

  addTable = (pdf: any, columns: string[], data: any[], top: number, left: number) => {
    pdf.autoTable(columns, data, {
      styles: {
        cellPadding: 2,
        fontSize: 12,
        font: "helvetica",
        tableLineColor: 163,
        tableLineWidth: 3,
        fontStyle: 'normal', // normal, bold, italic, bolditalic         
        overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
        fillColor: false, // false for transparent or a color as described below
        textColor: '#585858',
        halign: 'left', // left, center, right
        valign: 'middle', // top, middle, bottom
        columnWidth: 'wrap', // 'auto', 'wrap' or a num},
        lineWidth: 0.01,
        lineColor: 0,
        fillStyle: 'DF',
        tableWidth: (pdf.internal.pageSize.width / 2) - 30
      },
      columnStyles: {
        0: { fontStyle: 'bold', halign: 'center' },
        2: { fontStyle: 'normal', halign: 'center' }
      },
      theme: 'plain',
      headerStyles: { fillColor: false, fontStyle: 'bold' },
      bodyStyles: { fillColor: false, textColor: '#585858', font: "helvetica" },
      alternateRowStyles: { fillColor: false },
      margin: { top: top, left: left },
      tableWidth: (pdf.internal.pageSize.width / 2) - 30,
      tableLineColor: 163,
      tableLineWidth: 3
    });
  }

  addTableForCharts = (pdf: any, columns: string[], data: any[], top: number, left: number, columnStyles: any = {}, clientName, dateString, chartName, programDashboard: string = this.programDashboard) => {
    pdf.autoTable(columns, data, {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      addPageContent: (data) => {
        this.pdfService.writeHeaderAndFooter(pdf, clientName, dateString, chartName, programDashboard);
      },
      styles: {
        cellPadding: 2,
        cellSpacing: 1,
        fontSize: 8,
        font: "helvetica",
        tableLineColor: 163,
        tableLineWidth: 3,
        fontStyle: 'normal', // normal, bold, italic, bolditalic         
        overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
        fillColor: false, // false for transparent or a color as described below
        textColor: '#585858',
        halign: 'center', // left, center, right
        valign: 'middle', // top, middle, bottom
        columnWidth: (pdf.internal.pageSize.width - 48) / columns.length, // 'auto', 'wrap' or a num},
        lineWidth: 1,
        lineColor: 0,
        fillStyle: 'DF',
        tableWidth: (pdf.internal.pageSize.width / 2) - 30
      },
      columnStyles: columnStyles,
      theme: 'grid',
      headerStyles: { halign: 'center', fillColor: false, fontStyle: 'bold' },
      bodyStyles: { fillColor: false, textColor: '#585858', font: "helvetica" },
      alternateRowStyles: { fillColor: false },
      margin: { top: top, left: left },
      //tableWidth: (pdf.internal.pageSize.width/2)-30,
      tableLineColor: 163,
      tableLineWidth: 3
    });
  }

  drawLine(pdf: any, startX: number, startY: number, endX: number, endY: number) {
    this.setDrawColor(pdf);
    pdf.line(startX, startY, endX, endY);
  }

  drawRectangle(pdf: any, x: number, y: number, width: number, height: number) {
    this.setDrawColor(pdf);
    pdf.roundedRect(x, y, width, height, 3, 3, 'FD');
  }

  drawfullWidthRectangle = (pdf) => {
    const width = pdf.internal.pageSize.width;
    this.drawRectangle(pdf, 24, 130, width - 48, 325);
  }

  setDrawColor(pdf: any) {
    pdf.setDrawColor(0, 0, 0, 0.3);
    pdf.setLineWidth(0.6);
  }

  getChartId(chartName: string, type: string) {
    return chartName.toLowerCase().replace(new RegExp(' ', 'g'), '').replace(new RegExp('/', 'g'), '').replace(new RegExp('-', 'g'), '') + type;
  }

  sortFunction(a, b) {
    if (a[0] === b[0]) {
      return 0;
    }
    else {
      return (a[0] < b[0]) ? -1 : 1;
    }
  }

  protected convertSvgToPdf(svgElement: SVGSVGElement, pdf: any, options: any): void {
    svg2pdf(svgElement, pdf, options);
  }

}
